import { css } from '@inter-ikea-kompis/web-component';
import { Text } from '@ingka/common-styles-webc';
import * as colors from '@ingka/variables/colours-css';
import * as tokens from '@ingka/variables/design-tokens';
export default class BuyInStoreCardStyle {
    /**
     * Returns styles.
     *
     * @returns Styles.
     */
    static getStyle() {
        return css `
			${Text.CSS}

			:host {
				display: flex;
				flex-direction: column;
				height: 100%;
			}

			h2 {
				margin-top: 0;
				margin-bottom: ${tokens.space100};
			}

			.body {
				margin: 0;
			}

			skapa-inline-message {
				margin-top: ${tokens.space100};
			}

			.qr-code-container {
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				margin-top: ${tokens.space250};
				padding: ${tokens.space250};
				gap: ${tokens.space250};
				background-color: ${colors.colourStaticIkeaBrandBlue};
				border-radius: ${tokens.radiusM};
			}

			.qr-code-background {
				padding: ${tokens.space125};
				border-radius: ${tokens.radiusS};
				background-color: ${colors.colourStaticWhite};
			}

			kompis-qr-code {
				width: 13rem;
				height: 13rem;
			}

			.qr-code-help-text {
				margin: 0;
				color: ${colors.colourStaticWhite};
				font-weight: ${tokens.fontWeightBold};
				text-align: center;
			}
		`;
    }
}
//# sourceMappingURL=BuyInStoreCardStyle.js.map